// extracted by mini-css-extract-plugin
export default {"buttons":"ModalValidateCancel_buttons__Ej5th"};